import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { Dropdown } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { FullPetDetailsPropTypes } from '../../../propTypes/petDetails';
import { GetPetDropdownOptions } from '../../../helpers/petHelpers';
import './claimFilterBar.scss';
import { clearFullPolicyNumber } from '../../../store/slice/petDetailsSlice';
import { scrollToTop } from '../../../utils/scrollUtils';

export const ClaimFilterBar = ({
  petDetails,
  policyFilter,
  claimPanelFilter,
  onPetFilterChange,
  onClaimFilterChange
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const fieldFormContext = useFormContext();
  const { reset } = fieldFormContext;

  const petOptions = [{ label: 'All pets', value: '' }, ...GetPetDropdownOptions({ petDetails })];
  const claimStatusOptions = ['All claims', 'My saved claims', 'My open claims', 'My completed claims'];

  useEffect(() => {
    // Reset filters when the location (URL) changes
    scrollToTop();
    reset({
      claimFilter: claimPanelFilter || 'All claims',
      petFilter: policyFilter || ''
    });
    dispatch(clearFullPolicyNumber());
  }, [location, reset, claimPanelFilter, policyFilter, dispatch]);

  return (
    <div className="claimFilterBar">
      <h5 aria-hidden="true">Filter by</h5>
      <Dropdown
        fieldFormContext={fieldFormContext}
        name="claimFilter"
        defaultValue={claimPanelFilter || claimStatusOptions[0]}
        options={claimStatusOptions}
        label="Filter claims by claim status"
        hideLabel
        customChangeHandler={onClaimFilterChange}
        includeEmptyOption={false}
      />

      <Dropdown
        fieldFormContext={fieldFormContext}
        name="petFilter"
        defaultValue={policyFilter || petOptions[0]}
        options={petOptions}
        label="Filter claims by pet"
        hideLabel
        customChangeHandler={onPetFilterChange}
        includeEmptyOption={false}
      />
    </div>
  );
};

ClaimFilterBar.propTypes = {
  petDetails: PropTypes.arrayOf(FullPetDetailsPropTypes),
  policyFilter: PropTypes.string,
  claimPanelFilter: PropTypes.string,
  onPetFilterChange: PropTypes.func,
  onClaimFilterChange: PropTypes.func
};
